module.exports = __webpack_public_path__ + "static/media/icon-money.3eb5409b.svg";